import { PriorityValue } from '@/container/planning/Dialog/occasionalSlot/occasionalSlotForm/functions/priorityValues'
import { JSX, ReactNode } from 'react'

export type SelectOptionsDeprecated = Array<OptionsGroupDeprecated>

export interface OptionsGroupDeprecated {
    name?: string
    options: Array<SelectOptionDeprecated>
}

export interface SelectOptionDeprecated {
    name: string
    value: string
    disabled?: boolean
    startAdornment?: JSX.Element
}

//TODO: Remove deprecated interfaces on top
export type ValueType = string | number | undefined | PriorityValue

export type SelectOptions<T extends ValueType> = Array<OptionsGroup<T>>

export interface OptionsGroup<T extends ValueType> {
    name?: string
    options: Array<SelectOption<T>>
}

export interface SelectOption<T extends ValueType> {
    name: string
    value: T
    disabled?: boolean
    startAdornment?: JSX.Element
}

export interface HierarchicalOption {
    value: string
    name: string
    children?: HierarchicalOption[]
}

export interface SelectActionItem {
    label: string
    icon?: ReactNode
    onClick: () => void
}

export const ACTION_ITEM_VALUE: string = '__select-multiple-action__'
